import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const ValidateToken = createAsyncThunk(
  "ValidateToken",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingValidateToken(""));
      const response = await UsePortalApi(
        `Patient/ValidateToken`,
        "Post",
        payload, 
        true
      );
      if (response) {
        console.log(response , "response")
        dispatch(
          gettingValidateTokenSuccess(response)
        );
      } else {
        dispatch(
          gettingValidateTokenFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingValidateTokenFailed(error));
    }
  }
);
const ValidateTokenSlice = createSlice({
  name: "ValidateToken",
  initialState: {
    TokenValidator: false,
    isChecking: false,
    error: false,
  },
  reducers: {
    gettingValidateToken: (state, action) => {
      state.TokenValidator = null;
      state.isChecking = true;
      state.error = false;
    },
    gettingValidateTokenSuccess: (state, action) => {
      state.TokenValidator = action.payload;
      state.isChecking = false;
      state.error = false;
    },
    gettingValidateTokenFailed: (state, action) => {
      state.TokenValidator = null;
      state.isChecking = false;
      state.error = true;
    },
    gettingValidateTokenClear: (state, action) => {
      state.TokenValidator = null;
      state.isChecking = false;
      state.error = false;
    },
  },
});
export const {
  gettingValidateToken,
  gettingValidateTokenSuccess,
  gettingValidateTokenFailed,
  gettingValidateTokenClear,
} = ValidateTokenSlice.actions;
export default ValidateTokenSlice.reducer;
